import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { GroupAktie } from './groupaktie.entity';
//#endregion

export const GroupAktieConfig = {
  name: "GroupAktie",
  annotations: [],
  fields: {
    groupId: {type: 'Edm.Int32'},
    aktieId: {type: 'Edm.Int32'},
    sortValue: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    group: {type: 'entities.schema.Group', navigation: true, field: 'groupId', ref: 'id'},
    aktie: {type: 'entities.boerse.Aktie', navigation: true, field: 'aktieId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<GroupAktie>;